import { __module as sortAscending } from "../../../../../../_virtual/sortAscending.js";
var hasRequiredSortAscending;
function requireSortAscending() {
  if (hasRequiredSortAscending) return sortAscending.exports;
  hasRequiredSortAscending = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = sortAscending2;
    function sortAscending2(list) {
      return list.sort(function(a, b) {
        return a - b;
      });
    }
    module.exports = exports$1.default;
  })(sortAscending, sortAscending.exports);
  return sortAscending.exports;
}
export {
  requireSortAscending as __require
};
//# sourceMappingURL=sortAscending.js.map
